import { DialogTitle, DialogContent, DialogActions, Button } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { CreditType } from 'src/api/api.generated'
import CreditSingleSelect from 'src/app/components/form-fields/credit-single-select'
import useUpdateReservationCredit from '../../../../../api/update-credit.hook'
import useErrorSnackBar from 'src/app/hooks/error-snack-bar/error-snack-bar'
import { Popover } from '@vapor/material'

type UpdateCreditTypePopoverProps = {
  reservationId: string
  initialValue: CreditType
  open: boolean
  anchorEl: HTMLDivElement | null
  handleClose: () => void
}

export default function UpdateCreditTypePopover({ reservationId, initialValue, open, anchorEl, handleClose }: UpdateCreditTypePopoverProps) {
  const [creditType, setCreditType] = useState(initialValue)
  const { t } = useTranslation()
  const showError = useErrorSnackBar()

  const { updateCreditType, loading } = useUpdateReservationCredit()

  const onSaveClick = useCallback(async () => {
    const result = await updateCreditType(reservationId, creditType)
    if (result.type === 'SUCCESS') {
      handleClose()
    } else {
      showError(result.errors)
    }
  }, [updateCreditType, reservationId, creditType])

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
    >
      <DialogTitle>{t('pms.booking.reservation_new.options.credit_label')}</DialogTitle>
      <DialogContent>
        <CreditSingleSelect value={creditType} onChange={setCreditType} />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleClose} disabled={loading}>
          {t('commons.cancel')}
        </Button>
        <LoadingButton loading={loading} variant="contained" onClick={onSaveClick}>
          {t('commons.save')}
        </LoadingButton>
      </DialogActions>
    </Popover>
  )
}
